import { IResource } from "../i18n";

const translation_en_us: IResource = {
    header_title: 'MEET | frictionless interviews',
    header_menu_api: 'API',
    header_signup_text: 'Sign up free',
    header_signin_text: 'Sign in',
    header_dashboard_text: 'My dashboard',

    general_title_text: 'Frictionless interviews',
    general_cta_text_one: 'Save time, money and your nerves',
    general_cta_text_two: 'when organizing and conducting',
    general_cta_text_three: 'remote job interviews',
    general_cta_button: 'Try now for free',
    general_cta_contact: 'Contact Us: office@meet.rs',
    general_cta_consent_one: 'This site uses cookies only for analytics and personalization purposes.',
    general_cta_consent_two: 'By continuing to use this site, you agree with ',
    general_tos_text: 'Terms of Use',
    general_tos_tooltip: 'Vivani Meet Terms of Use',
    general_cookies_text: 'Cookie policy',
    general_cookies_tooltip: 'Vivani Meet Cookies policy',
    general_privacy_text: 'Privacy policy',
    general_privacy_tooltip: 'Vivani Meet Privacy policy',
    general_refund_text: 'Refunding policy',
    general_refund_tooltip: 'Vivani Meet Refund policy',

    usecase_title_head: 'Custom built for remote interviews',
    usecase_title_subhead: 'Everything has been designed based on the remote interview needs recruiters and interviewers have today',
    usecase_interviewer_title: 'INTERVIEWER FRIENDLY',
    usecase_interviewer_subtitle: 'Task library',
    usecase_interviewer_body: 'Setup the interview tasks upfront and enjoy the interview',
    usecase_interviewer_learnmore: 'Learn More ',
    usecase_interviewer_imgalt: 'Whiteboard interview',
    usecase_collaboration_title: 'WORK TOGETHER',
    usecase_collaboration_subtitle: 'Built for collaboration',
    usecase_collaboration_body_one: 'Call, code, draw, write ...',
    usecase_collaboration_body_two: 'All together, all at the same time.',
    usecase_collaboration_learnmore: 'Learn More ',
    usecase_collaboration_imgalt: 'Whiteboard interview',    
    usecase_recruiter_title: 'RECRUITER FRIENDLY',
    usecase_recruiter_subtitle: 'Doing your work for you',
    usecase_recruiter_body: 'Automatic scheduling, notes taking, participant reminders, feedback collection...',
    usecase_recruiter_learnmore: 'Learn More ',
    usecase_recruiter_imgalt: 'Whiteboard interview',    
    usecase_call_title: 'FULL HD GROUP VIDEO CALL',
    usecase_call_subtitle: 'With recording and transcription',
    usecase_call_body_one: 'Zero plugins, apps, installations',
    usecase_call_body_two: 'It just works on modern browsers!',
    usecase_call_learnmore: 'Learn More',
    usecase_call_imgalt: 'Whiteboard interview',     

    footer_email_text: "Contact us",

    signout_menu_text: "Sign out",
    me_menu_text: "My Meet",

    help_menu_text: "Help",

    cta_nosignup_text: "No sign-up or download required.",
    
    // Change language
    language_selector_title: "Language",
    language_en_title: "English",
    language_es_title: "Español",
    language_srLatn_title: "Srpski",
    language_srCyrl_title: "Српски",
    language_fr_title: "Français",
    language_de_title: "Deutsch",
    language_it_title: "Italian",
    language_pl_title: "Polski",

    general_cta_button_quick: "Host a Quick Meet",

    general_cta_text_all: "You are wasting a lot of time on the interviews fighting with a lot of the tools. Meet is a single specialized remote interview app doing it all. Focus on the candidate and forget about the tools.",

    header_title_short: "Vivani Meet"
}

export default translation_en_us;